export default __webpack_public_path__ + "static/media/flayerB.328c46f4.jpg";